/*
 * @Author: ouyangzhichao@kuaishou.com
 * @Date: 2023-03-07 07:44:32
 * @LastEditors: ouyangzhichao ouyangzhichao@kuaishou.com
 * @LastEditTime: 2023-08-17 02:02:54
 * @FilePath: /ad-dmp/src/utils/blankMonitor.ts
 * @Description:
 *
 * Copyright (c) 2023 by ${git_name_email}, All Rights Reserved.
 */
// 白屏异常

class BlankMonitor {
    // 白屏标记
    isBlankError = false;

    domContainer: HTMLElement | string;

    constructor(dom: HTMLElement | string) {
        this.domContainer = dom;
    }

    // 检查页面状态
    checkPageReady(callback: Function) {
        if (document.readyState === 'complete') {
            setTimeout(() => {
                callback();
            }, 500);
        } else {
            window.addEventListener(
                'load',
                function () {
                    setTimeout(() => {
                        callback();
                    }, 500);
                },
                false,
            );
        }
    }

    // 检查白屏
    monitor(callback: (err: Error) => void) {
        const self = this;
        window.addEventListener('error', function (error) {
            if (self.isBlankError) return;
            // checkPageReady()
            self.checkPageReady(() => {
                if (self.isBlankError) return;
                const container =
                    typeof self.domContainer === 'string'
                        ? document.querySelector(self.domContainer)
                        : self.domContainer;
                // 白屏-react16，任何未被错误边界捕获的错误将会导致整个react组件树被删除-整个app.tsx表示的DOM结构都会被删除
                if (!container?.children.length) {
                    // 针对ResizeObserver loop limit exceeded和ResizeObserver loop completed with undelivered notifications.错误，可忽略
                    if (
                        error.message === 'ResizeObserver loop limit exceeded' ||
                        error.message ===
                            'ResizeObserver loop completed with undelivered notifications.'
                    ) {
                        console.warn('Ignored:', error.message);
                        return;
                    }
                    console.error('[BlankScreenMonitor]===>', error.message);
                    self.isBlankError = true;
                    callback(error as unknown as Error);
                }
            });
        });
    }
}

// radar上报白屏异常
export const blankMonitor = new BlankMonitor(document.getElementById('root')!);
